import React, { useMemo } from "react";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";
import { ConfigProvider, theme as antdTheme } from "antd";
import { useTheme } from "../../style";

const BRAND = "#007bff";

/**
 * Мост темы для сторонних UI-библиотек.
 * Синхронизирует MUI и AntD с нашей темой (light/dark) — чтобы их компоненты
 * (таблицы, карточки, модалки, инпуты) темнели вместе с приложением, а не
 * оставались белыми. Bootstrap перекрашивается через data-bs-theme (см. ThemeContext).
 *
 * Должен быть внутри <ThemeProvider> (использует useTheme).
 */
export default function UiThemeBridge({ children }) {
  const { isDark } = useTheme();

  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: isDark ? "dark" : "light",
          primary: { main: BRAND },
        },
      }),
    [isDark],
  );

  const antdConfig = useMemo(
    () => ({
      algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
      token: { colorPrimary: BRAND },
    }),
    [isDark],
  );

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ConfigProvider theme={antdConfig}>{children}</ConfigProvider>
    </MuiThemeProvider>
  );
}
